import { imagePhp } from ".";

export const dummyProducts = [
  {
    id_product: 123,
    name: "Your product's title",
    categories: ["2", "4", "6"],
    description:
      "<p>While writing the full product description, the most important objective is to provide sufficient information. Address all the whys and wherefores of the product in detail, highlighting the words and phrases that are especially relevant to your audience. Don’t be worried about the length of the copy, so long as you are not using superfluous words to stuff your content.</p><p>An essential requirement of a product description is that you need to speak of both, the features and the benefits of the product, to woo your audience. Store owners tend to believe that customers are only concerned about how the product affects them and so look for the benefits of the product. However, this rides a lot on the kind of audience you are targeting, dont forget to list the following aspects of your description</p><ul><li>- Highlight quality</li><li>- Describe materials and textures</li><li>- Any other relevant information</li></ul><p>You may also add additional information such as shipping terms, warranty, refund policy and etc. Be convincing, and don't forget your call to action!</p></div>",
    description_short:
      "<p>A short product description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a short product description is to supply customers with an overview of important information about the features and benefits of the product so they’re compelled to buy.</p>",
    description_short_upsell:
      "<p>A short product upsell description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a short product description is to supply customers with an overview of important information about the features and benefits of the product so they’re compelled to buy.</p>",
    image: imagePhp + "/img/ph1.jpg",
    images: [
      imagePhp + "/img/ph1.jpg",
      imagePhp + "/img/ph2.jpg",
      imagePhp + "/img/ph3.jpg",
    ],
    review: 5,
    reviews: [
      {
        review_id: "5",
        id_lang: "0",
        id_shop: "0",
        id_currency: "0",
        review_title: "This product is Amazings, must buy.",
        author: "John Doe",
        description: "Good Quality, Quick Delivery.",
        product_id: "6",
        category_id: "0",
        manufacturer_id: "0",
        customer_id: "9999",
        email: "review@groovekart.com",
        current_status: "1",
        incentive_amount: "10",
        ratings: "5",
        certified_buyer: "1",
        enable_incentive: "1",
        helpful_votes: "12",
        not_helpful_votes: "2",
        date_add: "2020-02-29 16:43:22",
        date_updated: "2020-02-29 16:43:22",
      },
      {
        review_id: "5",
        id_lang: "0",
        id_shop: "0",
        id_currency: "0",
        review_title: "Good Quality, Quick Delivery.",
        author: "Jane Doe",
        description: "This product is amazing",
        product_id: "6",
        category_id: "0",
        manufacturer_id: "0",
        customer_id: "9999",
        email: "review@groovekart.com",
        current_status: "1",
        incentive_amount: "10",
        ratings: "5",
        certified_buyer: "1",
        enable_incentive: "1",
        helpful_votes: "12",
        not_helpful_votes: "2",
        date_add: "2020-02-29 16:43:22",
        date_updated: "2020-02-29 16:43:22",
      },
    ],
    bump_products: [],
    bundles: [],
    price: {
      "old-price": "$20.00",
      "reduced-price": "$15.00",
      "reduction-label": "SALE",
    },
  },
  {
    id_product: 1234,
    name: "Your product's title",
    categories: ["2", "4", "6"],
    description:
      "<p>While writing the full product description, the most important objective is to provide sufficient information. Address all the whys and wherefores of the product in detail, highlighting the words and phrases that are especially relevant to your audience. Don’t be worried about the length of the copy, so long as you are not using superfluous words to stuff your content.</p><p>An essential requirement of a product description is that you need to speak of both, the features and the benefits of the product, to woo your audience. Store owners tend to believe that customers are only concerned about how the product affects them and so look for the benefits of the product. However, this rides a lot on the kind of audience you are targeting, dont forget to list the following aspects of your description</p><ul><li>- Highlight quality</li><li>- Describe materials and textures</li><li>- Any other relevant information</li></ul><p>You may also add additional information such as shipping terms, warranty, refund policy and etc. Be convincing, and don't forget your call to action!</p></div>",
    description_short:
      "<p>A short product description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a short product description is to supply customers with an overview of important information about the features and benefits of the product so they’re compelled to buy.</p>",
    description_short_upsell:
      "<p>A short product upsell description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a short product description is to supply customers with an overview of important information about the features and benefits of the product so they’re compelled to buy.</p>",
    image: imagePhp + "/img/ph1.jpg",
    images: [
      imagePhp + "/img/ph1.jpg",
      imagePhp + "/img/ph2.jpg",
      imagePhp + "/img/ph3.jpg",
    ],
    review: 3,
    reviews: [
      {
        review_id: "5",
        id_lang: "0",
        id_shop: "0",
        id_currency: "0",
        review_title: "This is an amzing watch",
        author: "Bradd Pitt",
        description: "",
        product_id: "6",
        category_id: "0",
        manufacturer_id: "0",
        customer_id: "9999",
        email: "review@groovekart.com",
        current_status: "1",
        incentive_amount: "10",
        ratings: "5",
        certified_buyer: "1",
        enable_incentive: "1",
        helpful_votes: "12",
        not_helpful_votes: "2",
        date_add: "2020-02-29 16:43:22",
        date_updated: "2020-02-29 16:43:22",
      },
    ],
    bump_products: [],
    bundles: [],
    price: {
      "old-price": "$22.00",
      "reduced-price": "$14.00",
      "reduction-label": false,
    },
  },
  {
    id_product: 12345,
    name: "Your product's title",
    categories: ["2", "4", "6"],
    description:
      "<p>While writing the full product description, the most important objective is to provide sufficient information. Address all the whys and wherefores of the product in detail, highlighting the words and phrases that are especially relevant to your audience. Don’t be worried about the length of the copy, so long as you are not using superfluous words to stuff your content.</p><p>An essential requirement of a product description is that you need to speak of both, the features and the benefits of the product, to woo your audience. Store owners tend to believe that customers are only concerned about how the product affects them and so look for the benefits of the product. However, this rides a lot on the kind of audience you are targeting, dont forget to list the following aspects of your description</p><ul><li>- Highlight quality</li><li>- Describe materials and textures</li><li>- Any other relevant information</li></ul><p>You may also add additional information such as shipping terms, warranty, refund policy and etc. Be convincing, and don't forget your call to action!</p></div>",
    description_short:
      "<p>A short product description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a short product description is to supply customers with an overview of important information about the features and benefits of the product so they’re compelled to buy.</p>",
    description_short_upsell:
      "<p>A short product upsell description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a short product description is to supply customers with an overview of important information about the features and benefits of the product so they’re compelled to buy.</p>",
    image: imagePhp + "/img/ph1.jpg",
    images: [
      imagePhp + "/img/ph1.jpg",
      imagePhp + "/img/ph2.jpg",
      imagePhp + "/img/ph3.jpg",
    ],
    review: 4,
    reviews: [
      {
        review_id: "5",
        id_lang: "0",
        id_shop: "0",
        id_currency: "0",
        review_title: "This is an amzing watch",
        author: "Bradd Pitt",
        description: "",
        product_id: "6",
        category_id: "0",
        manufacturer_id: "0",
        customer_id: "9999",
        email: "review@groovekart.com",
        current_status: "1",
        incentive_amount: "10",
        ratings: "5",
        certified_buyer: "1",
        enable_incentive: "1",
        helpful_votes: "12",
        not_helpful_votes: "2",
        date_add: "2020-02-29 16:43:22",
        date_updated: "2020-02-29 16:43:22",
      },
    ],
    bump_products: [],
    bundles: [],
    price: {
      "old-price": "$50.00",
      "reduced-price": "$25.00",
      "reduction-label": false,
    },
  },
  {
    id_product: 123456,
    name: "Your product's title",
    categories: ["2", "4", "6"],
    description:
      "<p>While writing the full product description, the most important objective is to provide sufficient information. Address all the whys and wherefores of the product in detail, highlighting the words and phrases that are especially relevant to your audience. Don’t be worried about the length of the copy, so long as you are not using superfluous words to stuff your content.</p><p>An essential requirement of a product description is that you need to speak of both, the features and the benefits of the product, to woo your audience. Store owners tend to believe that customers are only concerned about how the product affects them and so look for the benefits of the product. However, this rides a lot on the kind of audience you are targeting, dont forget to list the following aspects of your description</p><ul><li>- Highlight quality</li><li>- Describe materials and textures</li><li>- Any other relevant information</li></ul><p>You may also add additional information such as shipping terms, warranty, refund policy and etc. Be convincing, and don't forget your call to action!</p></div>",
    description_short:
      "<p>A short product description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a short product description is to supply customers with an overview of important information about the features and benefits of the product so they’re compelled to buy.</p>",
    description_short_upsell:
      "<p>A short product upsell description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a short product description is to supply customers with an overview of important information about the features and benefits of the product so they’re compelled to buy.</p>",
    image: imagePhp + "/img/ph1.jpg",
    images: [
      imagePhp + "/img/ph1.jpg",
      imagePhp + "/img/ph2.jpg",
      imagePhp + "/img/ph3.jpg",
    ],
    review: 5,
    reviews: [
      {
        review_id: "5",
        id_lang: "0",
        id_shop: "0",
        id_currency: "0",
        review_title: "This is an amzing watch",
        author: "Bradd Pitt",
        description: "",
        product_id: "6",
        category_id: "0",
        manufacturer_id: "0",
        customer_id: "9999",
        email: "review@groovekart.com",
        current_status: "1",
        incentive_amount: "10",
        ratings: "5",
        certified_buyer: "1",
        enable_incentive: "1",
        helpful_votes: "12",
        not_helpful_votes: "2",
        date_add: "2020-02-29 16:43:22",
        date_updated: "2020-02-29 16:43:22",
      },
    ],
    bump_products: [],
    bundles: [],
    price: {
      "old-price": "$70.00",
      "reduced-price": "$45.00",
      "reduction-label": false,
    },
  },
  {
    id_product: 121,
    name: "Your product's title",
    categories: ["2", "4", "6"],
    description:
      "<p>While writing the full product description, the most important objective is to provide sufficient information. Address all the whys and wherefores of the product in detail, highlighting the words and phrases that are especially relevant to your audience. Don’t be worried about the length of the copy, so long as you are not using superfluous words to stuff your content.</p><p>An essential requirement of a product description is that you need to speak of both, the features and the benefits of the product, to woo your audience. Store owners tend to believe that customers are only concerned about how the product affects them and so look for the benefits of the product. However, this rides a lot on the kind of audience you are targeting, dont forget to list the following aspects of your description</p><ul><li>- Highlight quality</li><li>- Describe materials and textures</li><li>- Any other relevant information</li></ul><p>You may also add additional information such as shipping terms, warranty, refund policy and etc. Be convincing, and don't forget your call to action!</p></div>",
    description_short:
      "<p>A short product description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a short product description is to supply customers with an overview of important information about the features and benefits of the product so they’re compelled to buy.</p>",
    description_short_upsell:
      "<p>A short product upsell description is the marketing copy that explains what a product is and why it’s worth purchasing. The purpose of a short product description is to supply customers with an overview of important information about the features and benefits of the product so they’re compelled to buy.</p>",
    image: imagePhp + "/img/ph1.jpg",
    images: [
      imagePhp + "/img/ph1.jpg",
      imagePhp + "/img/ph2.jpg",
      imagePhp + "/img/ph3.jpg",
    ],
    review: 3,
    reviews: [
      {
        review_id: "5",
        id_lang: "0",
        id_shop: "0",
        id_currency: "0",
        review_title: "This is an amzing watch",
        author: "Bradd Pitt",
        description: "",
        product_id: "6",
        category_id: "0",
        manufacturer_id: "0",
        customer_id: "9999",
        email: "review@groovekart.com",
        current_status: "1",
        incentive_amount: "10",
        ratings: "5",
        certified_buyer: "1",
        enable_incentive: "1",
        helpful_votes: "12",
        not_helpful_votes: "2",
        date_add: "2020-02-29 16:43:22",
        date_updated: "2020-02-29 16:43:22",
      },
    ],
    bump_products: [],
    bundles: [],
    price: {
      "old-price": "$40.00",
      "reduced-price": "$35.00",
      "reduction-label": false,
    },
  },
];

export const dummyProduct = dummyProducts[0];
